import { IPanPlugin, ZoomRange } from '@/shared/Charting/LineChart/lineChart.types.ts'
import LineChart from '@/shared/Charting/LineChart'

const PanPlugin: () => IPanPlugin = () => ({
  chart: null as LineChart | null,
  dragging: false,
  lastX: 0,
  lastY: 0,
  init(chart: LineChart) {
    this.chart = chart
  },
  onMouseDown(e) {
    this.dragging = true
    this.lastX = e.offsetX
    this.lastY = e.offsetY
    this.chart.canvas.style.cursor = 'grabbing'
  },
  onMouseUp() {
    this.dragging = false
    this.chart.canvas.style.cursor = 'default'
  },
  onMouseMove(e) {
    if (!this.dragging) return
    const dx = e.offsetX - this.lastX
    const dy = e.offsetY - this.lastY

    const zoom = this.chart.zoom
    const xRange = zoom.xMax - zoom.xMin
    const yRange = zoom.yMax - zoom.yMin

    const pxPerX = (this.chart.canvas.width - this.chart.padding * 2) / xRange
    const pxPerY =
      (this.chart.canvas.height -
        this.chart.padding * 2 -
        this.chart.innerPadding.bottom -
        this.chart.innerPadding.top) /
      yRange

    const newZoomConfig: ZoomRange = {
      xMin: zoom.xMin - dx / pxPerX,
      xMax: zoom.xMax - dx / pxPerX,
      yMin: zoom.yMin + dy / pxPerY,
      yMax: zoom.yMax + dy / pxPerY,
    }
    this.chart.zoom.setZoom(newZoomConfig, 'pan-plugin')

    this.lastX = e.offsetX
    this.lastY = e.offsetY

    this.chart.render()
  },
})

export default PanPlugin
